import { Col, Form, Input, Row, Select, Typography } from "antd";
import React, { useEffect } from "react";
import { labelConfig } from "../../../customer/customer.config";
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

const CurrencyForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    currencyOptions,
    onChangeCurrency,
    tempChargeOptions,
    setChargeOptions,
  } = props;

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Currency</Text>}
            name="currencyCode"
            rules={[{ required: true, message: "Required Field" }]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.currency,
                "select"
              )}
              options={currencyOptions}
              onChange={onChangeCurrency}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Decimal Places</Text>}
            name="digitsAfterDecimal"
            rules={[{ required: true, message: "Required Field" }]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.decimalPlaces)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Multiples Of</Text>}
            name="inMultiplesOf"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.inMultiplesOf)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CurrencyForm;
